/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Sub_Sport_MountainInputs */

const en_ui_sub_sport_mountain = /** @type {(inputs: Ui_Sub_Sport_MountainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mountain`)
};

const de_ui_sub_sport_mountain = /** @type {(inputs: Ui_Sub_Sport_MountainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berg`)
};

/**
* | output |
* | --- |
* | "Mountain" |
*
* @param {Ui_Sub_Sport_MountainInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_sub_sport_mountain = /** @type {((inputs?: Ui_Sub_Sport_MountainInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Sub_Sport_MountainInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_sub_sport_mountain(inputs)
	return de_ui_sub_sport_mountain(inputs)
});